var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"available-courses-container"},[_c('top-bar',{attrs:{"state":_vm.topbarState,"scroll-top":_vm.scrollTop},on:{"update-topbar":_vm.updateTopbar}}),_c('CoursesList',{attrs:{"view":'',"courses":_vm.filteredCourses},on:{"scroll-topbar":_vm.scrollTopbar}}),_c('mobile-filters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }